export const teqip3_floater_menu={
    'head':'TEQIP-III',
    'links':[
        {
            'id':'6',
            'link':'Overview',
            'path':'/teqip3'
        },
        {
            'id':'1',
            'link':'TEQIP III – Officials',
            'path':'/t3_officials'
        },
        {
            'id':'2',
            'link':'Academic Activities',
            'path':'/t3_acad'
        },
        {
            'id':'3',
            'link':'Procurement',
            'path':'/t3_procure'
        },
        {
            'id':'4',
            'link':'Twinning Activities',
            'path':'/t3_twin'
        },
        {
            'id':'5',
            'link':'Audited Statement',
            'path':'https://drive.google.com/file/d/1wbyhHTTkMLfdO4GktLYsSelcXHF9sacx/view'
        }
    ]
}